'use client'

import { timezoneDateTime } from '@/helpers/datetime'
import { getCurrentOrNextSession } from '@/helpers/events'
import { formatDurationCountdown } from '@/lib/countdown'
import dayjs from '@/lib/dayjs'
import { useEffect, useMemo, useState } from 'react'

export function Countdown({
  events,
  labelText = 'Race starts in',
  countdownClassName = 'text-nowrap text-p-1! font-normal! text-neutral-blue-300!',
  countDownContainerClassName = 'flex h-5 items-center gap-1',
  liveContainerClassName = 'relative h-5 text-center font-bold',
  onlyRenderIfLive = false,
  onlyRenderIfCountdown = false,
}) {
  const currentOrNextSessionDateTimeTz = useMemo(() => {
    const currOrNextSession = getCurrentOrNextSession(events)
    return currOrNextSession?.targetDateTime &&
      currOrNextSession?.targetTimezone
      ? timezoneDateTime({
          datetime: currOrNextSession.targetDateTime,
          timezone: currOrNextSession.targetTimezone,
          format: false,
        })
      : null
  }, [events])

  const [countdown, setCountdown] = useState('')

  useEffect(() => {
    function updateCountdown() {
      const now = dayjs()

      if (currentOrNextSessionDateTimeTz.isBefore(now)) {
        setCountdown('LIVE')
        return
      }

      const diff = currentOrNextSessionDateTimeTz.diff(now)

      setCountdown(formatDurationCountdown(diff))
    }

    if (!currentOrNextSessionDateTimeTz) return
    updateCountdown()
    const intervalId = setInterval(updateCountdown, 1000)

    return () => clearInterval(intervalId)
  }, [currentOrNextSessionDateTimeTz])

  return (
    <div className="mx-auto">
      {currentOrNextSessionDateTimeTz && countdown === 'LIVE' ? (
        //live
        <>
          {onlyRenderIfCountdown !== true && (
            <div className={liveContainerClassName}>
              <p className="absolute font-syncopate uppercase text-success">
                LIVE
              </p>
              <p className="animate-[ping_2s_cubic-bezier(0,0,0.2,2)_infinite] font-syncopate uppercase text-success">
                LIVE
              </p>
            </div>
          )}
        </>
      ) : currentOrNextSessionDateTimeTz && countdown ? (
        //upcoming
        <>
          {onlyRenderIfLive !== true && (
            <div className={countDownContainerClassName}>
              <p className="text-nowrap text-p-1 font-normal text-neutral-blue-300">
                {labelText}
              </p>
              <p className={countdownClassName}>{countdown}</p>
            </div>
          )}
        </>
      ) : //finished
      null}
    </div>
  )
}
